import { apiSlice } from '@redux/api/apiSlice';
import colorPaletteReducer from '@redux/colorPaletteSlice';
import { combineReducers, configureStore, Middleware } from "@reduxjs/toolkit";

const rootReducer = combineReducers({
  [apiSlice.reducerPath]: apiSlice.reducer,
  colorPalette: colorPaletteReducer,
});
export const store = configureStore({
  reducer: rootReducer,
  devTools: process.env.NODE_ENV !== "production",
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apiSlice.middleware as Middleware),
});


export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;
